var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.series && _vm.series.length)?_c('b-card',{staticClass:"earnings-card",attrs:{"title":"Applications"}},[_c('vue-apex-charts',{attrs:{"options":_vm.getOptions(),"series":_vm.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }